import { t } from 'ember-intl';
import safeFormatDate from 'tio-common/helpers/safe-format-date';
import Component from '@glimmer/component';

interface AuthRegisterNotLaunchedComponentSignature {
  Args: {
    companyName: string;
    launchDate: string;
    daysUntilLaunch?: number;
  };
}

export default class AuthRegisterNotLaunched extends Component<AuthRegisterNotLaunchedComponentSignature> {
  get formatDays() {
    const days = this.args.daysUntilLaunch || 0;
    return `${days} day${days === 1 ? '' : 's'}`;
  }

  <template>
    <div class="p-5">
      <p class="text-xl mb-6">
        {{t
          "login.not_launched"
          companyName=@companyName
          date=(safeFormatDate @launchDate month="short" day="2-digit" year="numeric")
          days=this.formatDays
        }}
      </p>
    </div>
  </template>
}
